'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _reactImageGallery = require('react-image-gallery');
var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
require('react-image-gallery/styles/css/image-gallery.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  Carousel: {
    pointerEvents: function pointerEvents(_ref) {
      var editable = _ref.editable;
      return editable && 'none';
    }
    // height: 500,
    // '& .image-gallery-slides': {
    //   maxHeight: '500px',
    //   overflow: 'hidden',
    //   '& .image-gallery-slide': {
    //     maxHeight: '100%',
    //   }
    // }
  },
  imageContainer: {
    background: 'black',
    position: 'relative',
    height: 0,
    paddingTop: '56.25%'
  },
  slideImg: {
    objectFit: 'contain',
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  },
  textContainer: {
    color: 'white',
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.5) 75%, transparent 100%)',
    position: 'absolute',
    bottom: 0,
    maxHeight: '100%',
    width: '100%',
    overflow: 'hidden'
  },
  text: {
    margin: '3rem 4rem',
    lineHeight: 'initial',
    whiteSpace: 'pre-wrap'
  }
};
var Carousel = function (_Component) {
  _inherits(Carousel, _Component);
  function Carousel() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck(this, Carousel);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref2, [this].concat(args))), _this), _this.renderSlide = function (item) {
      var classes = _this.props.classes;
      return _react2.default.createElement('div', {
        className: classes.imageContainer
      }, _react2.default.createElement('img', {
        src: item.image,
        className: classes.slideImg
      }), item.text && _react2.default.createElement('div', {
        className: classes.textContainer
      }, _react2.default.createElement('p', {
        className: classes.text
      }, item.text)));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Carousel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        otherProperties = _props.otherProperties;
      var carouselSlides = otherProperties.carouselSlides;
      return _react2.default.createElement('div', {
        className: classes.Carousel
      }, !!carouselSlides && !!carouselSlides.length ? _react2.default.createElement(_reactImageGallery2.default, {
        items: carouselSlides,
        showThumbnails: false,
        renderItem: this.renderSlide,
        lazyLoad: true,
        showBullets: true,
        autoPlay: true,
        slideInterval: 5000
      }) : _react2.default.createElement('h2', null, 'Please insert some slides in the editor.'));
    }
  }]);
  return Carousel;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(Carousel);